module.exports = __webpack_public_path__ + "748c1395b4de0519a279cb1891435eda.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/face/eyepatch.png
// module id = 2430
// module chunks = 0